/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import {
    getBasenameAndExtension,
    isValidImageExtension,
    isValidDocumentExtension
} from "./extensions";

export const validateFileName = (filename, type) => {
    
    const [basename, ext] = getBasenameAndExtension(filename);
    const isValidImg = isValidImageExtension(ext);
    const isValidDoc = isValidDocumentExtension(ext);
    const isImage = type === "image";
    const isDocument = type === "document";

    // Ensure the file name doesn't exceed 256 characters
    if (filename.length > 64) {
        return false;
    }
    
    // Check if the extension is in the allowed set
    if (isImage && !isValidImg) {
        return false;
    }
    if (isDocument && !isValidDoc) {
        return false;
    }

    // Check the base name only contains lowercase alphanumeric characters and dashes
    const baseNameRegex = /^[a-z0-9]+(-[a-z0-9]+)*$/;
    if (!baseNameRegex.test(basename)) {
        return false;
    }

    // Ensure the base name has a maximum of 4 words separated by dashes
    const wordCount = basename.split("-").length;
    if (wordCount > 4) {
        return false;
    }

    return true;
};

